import type { RouteRecordRaw } from 'vue-router'

/**
 * 用户注册流程路由配置
 * 包含性别选择、出生年份、出生月份、身高、居住地、家乡、婚姻状况等页面
 */
export const registerRoutes: RouteRecordRaw[] = [
  {
    path: '/register',
    name: 'Register',
    redirect: '/register/gender',
    meta: {
      title: '用户注册',
      requiresSalesAuth: true,
      requiresUserAuth: true,
    },
  },
  {
    path: '/register/gender',
    name: 'RegisterGender',
    component: () => import('@/views/information/pagesGender.vue'),
    meta: {
      title: '选择性别',
      keepAlive: true,
      requiresSalesAuth: true,
      requiresUserAuth: true,
    },
  },
  {
    path: '/register/birth-year',
    name: 'RegisterBirthYear',
    component: () => import('@/views/information/pagesBirthYear.vue'),
    meta: {
      title: '选择出生年份',
      keepAlive: true,
      requiresSalesAuth: true,
      requiresUserAuth: true,
    },
  },
  {
    path: '/register/birth-month',
    name: 'RegisterBirthMonth',
    component: () => import('@/views/information/pagesBirthMonth.vue'),
    meta: {
      title: '选择出生月份',
      keepAlive: true,
      requiresSalesAuth: true,
      requiresUserAuth: true,
    },
  },
  {
    path: '/register/height',
    name: 'RegisterHeight',
    component: () => import('@/views/information/pagesHeight.vue'),
    meta: {
      title: '选择身高',
      keepAlive: true,
      requiresSalesAuth: true,
      requiresUserAuth: true,
    },
  },
  {
    path: '/register/hometown',
    name: 'RegisterHometown',
    component: () => import('@/views/information/pagesHometown.vue'),
    meta: {
      title: '选择家乡',
      keepAlive: true,
      requiresSalesAuth: true,
      requiresUserAuth: true,
    },
  },
  {
    path: '/register/habitation',
    name: 'RegisterHabitation',
    component: () => import('@/views/information/pagesHabitation.vue'),
    meta: {
      title: '选择居住地',
      keepAlive: true,
      requiresSalesAuth: true,
      requiresUserAuth: true,
    },
  },
  {
    path: '/register/marriage',
    name: 'RegisterMarriage',
    component: () => import('@/views/information/pagesMarriage.vue'),
    meta: {
      title: '选择婚姻状况',
      keepAlive: true,
      requiresSalesAuth: true,
      requiresUserAuth: true,
    },
  },
  {
    path: '/register/education',
    name: 'RegisterEducation',
    component: () => import('@/views/information/pagesEducation.vue'),
    meta: {
      title: '选择学历',
      keepAlive: true,
      requiresSalesAuth: true,
      requiresUserAuth: true,
    },
  },
  {
    path: '/register/income',
    name: 'RegisterIncome',
    component: () => import('@/views/information/pagesIncome.vue'),
    meta: {
      title: '选择月收入',
      keepAlive: true,
      requiresSalesAuth: true,
      requiresUserAuth: true,
    },
  },
  {
    path: '/register/phone',
    name: 'RegisterPhone',
    component: () => import('@/views/information/pagesPhone.vue'),
    meta: {
      title: '绑定手机号',
      keepAlive: true,
      requiresSalesAuth: true,
      requiresUserAuth: true,
    },
  },
  {
    path: '/register/description',
    name: 'RegisterDescription',
    component: () => import('@/views/information/pagesDescription.vue'),
    meta: {
      title: '相亲说明',
      keepAlive: true,
      requiresSalesAuth: true,
      requiresUserAuth: true,
    },
  },
  {
    path: '/register/institution',
    name: 'RegisterInstitution',
    component: () => import('@/views/information/pagesInstitution.vue'),
    meta: {
      title: '学院',
      keepAlive: true,
      requiresSalesAuth: true,
      requiresUserAuth: true,
    },
  },
  {
    path: '/register/houseSituation',
    name: 'RegisterHouseSituation',
    component: () => import('@/views/information/pagesHouseSituation.vue'),
    meta: {
      title: '购房情况',
      keepAlive: true,
      requiresSalesAuth: true,
      requiresUserAuth: true,
    },
  },
  {
    path: '/register/carSituation',
    name: 'RegisterCarSituation',
    component: () => import('@/views/information/pagesCarSituation.vue'),
    meta: {
      title: '购车情况',
      keepAlive: true,
      requiresSalesAuth: true,
      requiresUserAuth: true,
    },
  },

  {
    path: '/register/occupation',
    name: 'RegisteOccupation',
    component: () => import('@/views/information/pagesOccupation.vue'),
    meta: {
      title: '职业',
      keepAlive: true,
      requiresSalesAuth: true,
      requiresUserAuth: true,
    },
  },
  {
    path: '/register/photo',
    name: 'RegisterPhoto',
    component: () => import('@/views/information/pagesPhoto.vue'),
    meta: {
      title: '上传照片',
      keepAlive: true,
      requiresSalesAuth: true,
      requiresUserAuth: true,
    },
  },
]
